import styled from 'styled-components';
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';
import { HOME_PAGE } from "../../../../themes/css-global-classes";
import { DefaultBox, MobileBox } from "./jackpot-widget-wrapper.default.box";

export const PcBox = styled(DefaultBox)`
    width: calc((100% / 7) * 2);

    /**
     * When the paged is scaled down due to html font-size (rem units), make the widget smaller so it won't look like a Goliath.
     * Scale to 90%
     */
    @media ${({theme}) => theme.mediaQuery.xlAndBelow}, ${({theme}) => theme.mediaQuery.lowHeight} {
        .${HOME_PAGE} & {
            width: calc((100% / 6) * 2 * 0.9);
        }
    }
`;

export const JackpotWidgetCasino777Box = styledByDevice(PcBox, MobileBox);
